import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
  Tab,
  Tabs,
} from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ULoading, UText } from "@/components/index"
import Slider from "@mui/material/Slider"
import { wasmModule } from "@/gluelayer"
import { setOpenLabelPreview } from "@/UDTreat/udTreatSlice"
import { EShowArchType } from "@/gluelayer/core/common/types"
import { EArchType } from "@/gluelayer"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
export const LabelWindow = () => {
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { openStlPrint, curArch } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  const [sizeVal, setSizeVal] = useState(null)
  const [isloading, setIsloading] = useState(false)

  const handleChangeSize = (event: Event, newValue: number) => {
    setSizeVal(newValue)
  }
  const handleChangeCommittedSize = (event: Event, newValue: number) => {
    passValToWasm()
  }
  const [heightVal, setHeightVal] = useState(null)
  const handleChangeHeight = (event: Event, newValue: number) => {
    setHeightVal(newValue)
  }
  const handleChangeCommittedHeight = (event: Event, newValue: number) => {
    passValToWasm()
  }
  // label preview value to wasm
  const passValToWasm = () => {
    if (sizeVal === null || heightVal === null) {
      return
    }
    const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
    const existArch = wasmModule.mouthModel.GetArchsExistInfo()
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (printMoudle && printMoudle.SetLabelScale) {
      let arch = 0
      if (curArch === "up" && hasUpper) {
        arch = 0
      } else if (curArch === "low" && hasLower) {
        arch = 1
      } else {
        // both arch
        if (hasUpper) arch = 0
        else if (hasLower) arch = 1
      }
      console.log(
        "existArch: ",
        existArch,
        ", curArch: ",
        curArch,
        ", arch: ",
        arch,
      )
      console.log("heightVal", heightVal)
      console.log("sizeVal", sizeVal)
      // existArch != EShowArchType.

      setIsloading(true)
      setTimeout(() => {
        console.log("gowasm", heightVal, sizeVal, arch)
        printMoudle.SetLabelScale(heightVal, sizeVal, arch)
        setIsloading(false)
      }, 200)
    }
  }
  useEffect(() => {
    try {
      passValToWasm()
    } catch (error) {
      console.error(error)
    }
  }, [])
  // switch arch get value to reset the slider
  useEffect(() => {
    try {
      if (curArch !== "up" && curArch !== "low") {
        return
      }
      const printMoudle = wasmModule.moduleManager.GetModulePrintSelection()
      const res = printMoudle.GetLabelScale(curArch === "up" ? 0 : 1) || ""
      const sizeV = res.split(",")[0]
      const heightV = res.split(",")[1]
      if (sizeV !== "") {
        setSizeVal(+sizeV)
      }
      if (heightV !== "") {
        setHeightVal(+heightV)
      }
    } catch (error) {
      console.error(error)
    }
  }, [curArch])
  return (
    <Box
      sx={{
        width: "40%",
        height: "164px",
        position: "absolute",
        bottom: "0",
        padding: "16px 16px 24px 48px",
        background: "#fff",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "calc(100% - 16px)",
          padding: "6px 16px",
          borderRadius: "4px",
          background: "rgba(255, 255, 255, 0.40)",
          left: "8px",
          top: "-76px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <InfoOutlinedIcon sx={{ color: "#fff" }} />
        <Box
          sx={{
            color: "var(--info-contrast, #FFF)",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "143%",
            letterSpacing: "0.15px",
            marginLeft: "12px",
            padding: "8px 0",
          }}
        >{`Click on the model to place two dots to define the starting position and direction of the label.
Adjustments will apply to all the stages selected for output. `}</Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <UText variant={"h6"}>{`Label Preview`}</UText>
        <Button
          onClick={() => {
            // GoToOrigin3DScene
            const printMoudle =
              wasmModule.moduleManager.GetModulePrintSelection()
            if (printMoudle) {
              printMoudle.ApplyInPreview()
              printMoudle.GoToOrigin3DScene()
              dispatch(setOpenLabelPreview(false))
            }
          }}
          variant="contained"
          sx={{ height: "30px", padding: "4px 10px" }}
          endIcon={<ArrowForwardIosIcon sx={{ fontSize: "14px!important" }} />}
        >{`Back`}</Button>
      </Box>
      <Box className={"leftRight"} sx={{ width: "50%", marginTop: "14px" }}>
        <Box sx={{ display: "flex", marginLeft: "72px", marginBottom: "10px" }}>
          <UText variant={"subtitle1"}>{`Size`}</UText>
          <Slider
            sx={{ margin: "0 20px" }}
            value={sizeVal}
            onChange={handleChangeSize}
            onChangeCommitted={handleChangeCommittedSize}
          />
        </Box>
        <Box sx={{ display: "flex", marginLeft: "50px" }}>
          <UText variant={"subtitle1"}>{`Height`}</UText>
          <Slider
            sx={{ margin: "0 20px" }}
            value={heightVal}
            onChange={handleChangeHeight}
            onChangeCommitted={handleChangeCommittedHeight}
          />
        </Box>
      </Box>

      <ULoading isLoading={isloading} />
    </Box>
  )
}
